



















import Vue from 'vue'
import { RadioButtonGroupElInterface } from '@/config/interfaces'

export default Vue.extend({
  name: 'RadioButtonGroupEl',

  mounted () {
    this.selected = this.templateItemData.value
  },

  data: () => ({
    selected: ''
  }),

  props: {
    templateItemData: {
      type: Object as () => RadioButtonGroupElInterface,
      required: true
    }
  }
})
